export const msInH = 60 * 60 * 1000;
const dInMs = 1000 * 60 * 60 * 24;
const dPerH = 1 / 24;
export const dToMs = (d: number): number => Math.round(24 * d * msInH);
export const dToMsOpt = (
  d: number | undefined | null,
): number | undefined | null => (d != null ? Math.round(24 * d * msInH) : d);
export const hToMs = (h: number): number => Math.round(h * msInH);
export const msToH = (ms: number): number => ms / msInH;
export const msToHOpt = (ms: number | null): number | null =>
  ms !== null ? ms / msInH : null;
export const msToD = (ms: number): number => ms / dInMs;
export const hToD = (h: number): number => h * dPerH;
export const dToH = (d: number): number => d * 24;

export function roundHours(targetDate: number) {
  const date = new Date(targetDate);

  const minutes = date.getMinutes();
  date.setMinutes(0);
  if (minutes >= 30) {
    date.setHours(date.getHours() + 1);
  }

  return date.getTime();
}
